import logoUrl from '../../assets/d3-logo.png';
import { BaseComponent } from '../../lib/base-component.js';
import { html } from '../../lib/lit.js';
import { router } from '../../lib/router.js';

/**
 * The shared top navigation bar: the brand (left, always — links home), an
 * optional title (the `center` slot), and right-aligned actions (the `actions`
 * slot, e.g. the signed-in user and Sign Out).
 *
 * Three equal-width zones (flex: 1 1 0) so a centered title sits dead-centre
 * regardless of how wide the sides are. `container` sets how wide the row runs
 * (a Bootstrap container class). Mirrors <vtt-navbar> so the two apps read as
 * one family.
 */
export class CommunityNavbar extends BaseComponent {
    static properties = {
        container: { type: String },
    };

    constructor() {
        super();
        this.container = 'container-xxl';
    }

    render() {
        return html`
            <nav class="navbar bg-white border-bottom shadow-sm flex-shrink-0">
                <div class="${this.container} d-flex align-items-center">
                    <div class="d-flex align-items-center" style="flex: 1 1 0; min-width: 0;">
                        <a
                            href="/"
                            class="navbar-brand fw-semibold text-decoration-none mb-0"
                            @click=${(e) => {
                                e.preventDefault();
                                router.navigate('/');
                            }}
                        >
                            <img
                                src=${logoUrl}
                                alt=""
                                class="me-2"
                                style="height: 28px; width: auto;"
                            />Dice Driven Community
                        </a>
                    </div>
                    <div
                        class="d-flex align-items-center justify-content-center px-2"
                        style="flex: 1 1 0; min-width: 0;"
                    >
                        <slot name="center"></slot>
                    </div>
                    <div class="d-flex align-items-center justify-content-end gap-3" style="flex: 1 1 0;">
                        <slot name="actions"></slot>
                    </div>
                </div>
            </nav>
        `;
    }
}

if (!customElements.get('community-navbar')) {
    customElements.define('community-navbar', CommunityNavbar);
}
